import { call, put, takeLatest , select, all } from 'redux-saga/effects'
import {store} from "../../../utils/store";
import {IMAGE_UPLOAD_REQUEST, IMAGE_UPLOAD_COMPLETED, IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD } from "../constants"
import {setUploadProgressData , setUploadFailure ,setUploadSuccess } from "../actions"
import remote from '../../../services/remote'
import SentryManager from "../../../monitoring/Sentry";
import { getCase as getCaseAdmin } from "../../../containers/Layouts/Admin/AdminCaseDetails/actions"
import { getCase as getCaseUser } from "../../../containers/Layouts/User/CaseDetails/actions"

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function startProgressUpdates(file) {
    let progress = 0;
    const maxProgress = 90;  // Simulate progress until 90%
    let timeoutId;  // Reference to manage the timeout
    const updateProgress = () => {
        if (progress < maxProgress) {
            progress += getRandomInt(20, 30);  // Increment by random between 20 and 30
            if (progress > maxProgress) {
                progress = maxProgress;
            }
            // bad hack. we can use yield only in decorators.
            store.dispatch(setUploadProgressData({ fileName: file.filename, progress }))
            timeoutId = setTimeout(updateProgress, 500);  // Schedule next update
        }
    };

    updateProgress();  // Start updating progress

    // Return a cleanup function to clear the timeout
    return () => {
        clearTimeout(timeoutId);
    };
}

function* uploadImage(file,caseId) {
    // Start progress updates and get cleanup function
    const stopProgressUpdates = startProgressUpdates(file);

    try {
        const response = yield call(remote, {
            route: '/get-signed-url',
            method: 'post',
            body: JSON.stringify({
                fileName: file.filename,
                contentType: file.contentType,
                bookingId: caseId,
            })
        });

        if (response.success) {
            const { signedUrl, fileUrl } = response.data;
            const uploadResponse = yield call(fetch, signedUrl, {
                method: 'PUT',
                body: file.binary,
                headers: {
                    "Content-Type": file.contentType
                },
            });

            if (uploadResponse.ok) {
                const saveDBRequest = yield call(remote, {
                    route: '/bookings/add-image',
                    method: 'post',
                    body: JSON.stringify({
                        bookingId: caseId,
                        images: [{filename: file.filename, imageSrc: fileUrl}]
                    })
                });

                if (saveDBRequest.success) {
                    stopProgressUpdates();
                    yield put(setUploadSuccess({ fileName: file.filename, imageSrc: fileUrl }));
                } else {
                    stopProgressUpdates();
                    yield put(setUploadFailure({fileName: file.filename, error: response.error || "image Upload failed"}))
                }
            } else {
                stopProgressUpdates();
                yield put(setUploadFailure({fileName: file.filename, error: response.error || "image Upload failed"}))
            }
        } else {
            stopProgressUpdates();
            yield put(setUploadFailure({fileName: file.filename, error: response.error || "image Upload failed"}))
        }
    } catch (e) {
        console.error(e);
        stopProgressUpdates();
        SentryManager.captureException(e);
        yield put(setUploadFailure({fileName: file.filename, error: e.error || "image Upload failed"}));
    }
}

function* processUploadingImages (action) {
    const imageData = yield select(state => state.imageUploadReducer.uploads);
    const { caseId, isAdmin, getCase = true } = action.payload;
    const getCaseRequest = isAdmin ? getCaseAdmin : getCaseUser;
    const tasks = [];
    for (const file of Object.values(imageData)) {
        if (file.status === IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD) {
            tasks.push(call(uploadImage, file, caseId))
        }
    }

    try {
        yield all(tasks);
        yield put({ type: IMAGE_UPLOAD_COMPLETED });
        if (getCase) {
            yield put(getCaseRequest(caseId));
        }
    } catch (e) {
        yield put({ type: IMAGE_UPLOAD_COMPLETED });
        if (getCase) {
            yield put(getCaseRequest(caseId));
        }
    }
}


export default function* watchImageUploadSaga() {
    yield takeLatest(IMAGE_UPLOAD_REQUEST, processUploadingImages);
}



// WEBPACK FOOTER //
// ./src/shared/redux/saga/imageUploadSaga.js